import ajax from '@/utils/ajax';

const header = '/web';

export const getRegisTrationList = async () => {
    const { data } = await ajax(`${header}/v1/ai-table/list`);
    return data;
};

export const postRegisTrationList = async (recordId) => {
    const { data } = await ajax(`${header}/v1/ai-table/decr?recordId=${recordId}`);
    return data;
};
